import { Reveal, SectionTag, Polaroid, Tape, StarDoodle } from "@/components/doodles";

const BL_IMG = "/img/blacklabel.png";
const SHOP_URL = "https://rstr.co/blacklabelsupplements/4631";

export const Sponsor = () => (
  <section id="sponsor" className="py-24 sm:py-32">
    <div className="max-w-6xl mx-auto px-5 sm:px-8">
      <Reveal>
        <div className="card-pop bg-white grid lg:grid-cols-2 overflow-hidden" data-testid="sponsor-panel">
          <div className="p-8 sm:p-12 lg:p-14 flex flex-col justify-center order-2 lg:order-1">
            <SectionTag className="text-pink">SPONSOR SPOTLIGHT</SectionTag>
            <h2 className="font-display font-extrabold uppercase text-3xl sm:text-4xl tracking-tight mt-3 leading-[1.02]">
              PROUD <span className="hl-pink">BLACK LABEL</span> SUPPLEMENTS ATHLETE.
            </h2>
            <p className="mt-5 text-base sm:text-lg font-semibold text-ink/70 leading-relaxed max-w-lg">
              "You weren't chosen by accident." I'm officially repping the Black Label team — athletes who compete
              with intensity, carry themselves with integrity, and push the standard higher every single day.
              GRIND. HUSTLE. WIN. REPEAT!
            </p>
            <div className="mt-7 flex flex-wrap items-center gap-4">
              <a
                href={SHOP_URL}
                target="_blank"
                rel="noopener noreferrer sponsored"
                data-testid="sponsor-shop-link"
                className="btn-pop bg-ink text-cream px-6 py-4 text-sm sm:text-base"
              >
                Shop Black Label <StarDoodle className="w-4 h-4 text-lime" />
              </a>
              <div className="flex items-center gap-2 -rotate-2">
                <span
                  className="font-bebas tracking-[0.15em] bg-lime border-[2.5px] border-ink px-3 py-1.5 text-lg shadow-[3px_3px_0_#0d0d0d]"
                  data-testid="sponsor-code-chip"
                >
                  CODE: RO15
                </span>
                <span className="font-hand text-xl text-ink/60">= 15% off</span>
              </div>
            </div>
            <p className="font-hand text-2xl text-royal mt-6 rotate-1">my code, my discount, your gain — you're welcome</p>
          </div>
          <div className="relative p-8 sm:p-12 lg:p-14 flex items-center justify-center bg-offwhite order-1 lg:order-2">
            <div className="relative w-full max-w-xs sm:max-w-sm">
              <Polaroid
                eager
                src={BL_IMG}
                alt="Rosa holding her Black Label Supplements welcome card"
                rotate="rotate-2"
                caption="officially part of the team"
                className="w-full"
              />
              <Tape className="-top-3 left-1/2 -translate-x-1/2 -rotate-2" />
              <span className="absolute -bottom-3 -left-4 bg-pink text-cream border-[2.5px] border-ink font-bebas tracking-[0.2em] text-xs px-3 py-1.5 shadow-[3px_3px_0_#0d0d0d] -rotate-6">
                OFFICIAL ATHLETE
              </span>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
